import React, { useState } from 'react'
import ExclamationCircleIcon from '../../icons/ExclamationCircleIcon'
import { TooltipBox } from './TooltipBox'
interface TooltipIconProps {
  tooltipText: string
}

const TooltipIcon: React.FC<TooltipIconProps> = ({ tooltipText }) => {
  const [expanded, setExpanded] = useState(false)

  const handleMouseEnter = (): void => {
    setExpanded(true)
  }

  const handleMouseLeave = (): void => {
    setExpanded(false)
  }

  return (
    <div
      className="relative w-1/2"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div className="flex items-center h-full mx-2 text-2xl">
        <ExclamationCircleIcon color="#052A3E" />
      </div>
      <div className="w-full">
        {expanded && <TooltipBox text={tooltipText} />}
      </div>
    </div>
  )
}

export default TooltipIcon
